module.exports = __webpack_public_path__ + "static/media/customer-success-philips-digital-signage.e046955b.jpg";